<template>
  <div class="accountAndSubscriptionCreationDashboard">
    <vue-scroll :ops="ops">
      <div class="accountAndSubscriptionCreationDashboard__header">
        <div class="accountAndSubscriptionCreationDashboard__title">Account and/or membership creation</div>
      </div>
      <div class="accountAndSubscriptionCreation__items">
        <div class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">Email</div>
          <textarea v-model="email" />
          <div class="accountAndSubscriptionCreationDashboard__button check" @click="checkAccount">
            <span class="text">Check account</span>
          </div>
          <label v-if="checked">{{account ? '' : 'Account not found'}}</label>
        </div>
        <div v-if="checked" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">First Name</div>
          <textarea v-model="firstName" />
        </div>
        <div v-if="checked" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">Middle Name</div>
          <textarea v-model="middleName" />
        </div>
        <div v-if="checked" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">Last Name</div>
          <textarea v-model="lastName" />
        </div>
        <div v-if="checked" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">Mobile</div>
          <textarea v-model="mobile" />
        </div>
        <div v-if="account && account.plan" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title-subscription">{{account.plan}} {{new Date(account.startDate).toLocaleDateString('en-US')}} - {{new Date(account.endDate).toLocaleDateString('en-US')}} {{account.status}} {{account.IsAppleSubscription ? 'Is apple subscription' : ''}}</div>
        </div>
        <div v-if="checked && !account" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">Password</div>
          <textarea v-model="password" />
        </div>
        <div v-if="checked && (!account || (account && account.subscriptionStatusId !== 5 && account.subscriptionStatusId !== 6))" class="accountAndSubscriptionCreation__row">
          <div class="accountAndSubscriptionCreation__row__title">Duration</div>
          <input
            type="number"
            v-model="subscriptionDuration"
          />
        </div>
      </div>
      <div v-if="checked && (!account || (account && account.subscriptionStatusId !== 5 && account.subscriptionStatusId !== 6))" class="accountAndSubscriptionCreation__plan-radio-group-container">
        <div v-for="item in getPlans()" :key="item.id" class="accountAndSubscriptionCreation__plan-radio-group">
          <input
            :id="'plan-input-'+ item.id"
            v-model="selectedPlan"
            type="radio"
            name="plan"
            class="radio-input"
            :value="item"
          >
          <label class="radio-label">{{getDisplayValuePlan(item)}}</label>
        </div>
      </div>
      <div v-if="checked && !created && !account && firstName && lastName && password" class="accountAndSubscriptionCreation__row">
        <div class="accountAndSubscriptionCreationDashboard__button bottom" @click="createAccountAndSubscription">
          <span class="text">Create account</span>
        </div>
      </div>
      <div v-if="checked && !created && account && account.subscriptionStatusId !== 5 && account.subscriptionStatusId !== 6 && !account.IsAppleSubscription && selectedPlan.id !== 0" class="accountAndSubscriptionCreation__row">
        <div class="accountAndSubscriptionCreationDashboard__button bottom" @click="addSubscription(account.id)">
          <span class="text">Add subscription</span>
        </div>
      </div>
      <div>
        <div class="accountAndSubscriptionCreationDashboard__button" @click="clear">
          <span class="text">Clear</span>
        </div>
      </div>
    </vue-scroll>
    <InfoPopup />
  </div>
</template>

<script>
import {usersAPI} from '@/api/accounts'
import {subscriptionApi} from '@/api/flyer/subscriptions';
import {mapGetters} from 'vuex';
import './AccountAndSubscriptionCreation.styl'
import InfoPopup from '@/components/common/modals/InfoPopup';

export default {
    name: 'accounts-subscriptions-creation',
    data: () => ({
        email: '',
        checked: false,
        account: null,
        selectedPlan: {
          id: 0,
          name: 'Without subscription',
        },
        firstName: '',
        middleName: '',
        lastName: '',
        password: '',
        subscriptionDuration: '1',
        created: false,
        ops: {
          rail: {
            size: '3px',
          },
          bar: {
            size: '3px',
            background: 'rgba(0,0,0,0.1)',
          },
        },
    }),
    methods: {
      async checkAccount () {
        const response = await usersAPI.checkAccountAndSubscription(this.email);
        this.checked = response.data.isSuccessfull;
        this.password = '';
        if (this.checked) {
          this.created = false;
          if (response.data.item) {
            this.account = response.data.item;
            this.firstName = this.account?.firstName;
            this.middleName = this.account?.middleName;
            this.lastName = this.account?.lastName;
            this.mobile = this.account?.mobile;
          } else {
            this.account = null;
            this.firstName = '';
            this.middleName = '';
            this.lastName = '';
            this.mobile = '';
          }
        }
      },
      async createAccountAndSubscription () {
        const req = {
          accountType: 1,
          firstName: this.firstName,
          middleName: this.middleName,
          lastName: this.lastName,
          companyName: null,
          mobile: this.mobile,
          email: this.email,
          password: this.password,
          needConfirmation: false,
        }
        const signUpResult = await usersAPI.signUp(req);
        if (signUpResult.data.isSuccessfull) {
          if (this.selectedPlan.id !== 0) {
            await this.addSubscription(signUpResult.data.item.id, true);
          } else {
            this.created = true;
            this.showInfoPopup('Success', 'Account was created.');
          }
        } else {
          this.showInfoPopup('Error', signUpResult.data.message)
        }
      },
      async addSubscription (accountId, accountCreated) {
        const freeSubscriptionReq = {
            accountId,
            subscriptionPlanId: this.selectedPlan.id,
            duration: this.subscriptionDuration,
          };
          const createFreeSubscriptionRes = await subscriptionApi.createFreeSubscription(freeSubscriptionReq);
          if (createFreeSubscriptionRes.data.isSuccessfull) {
            this.created = true;
            if (accountCreated) {
              this.showInfoPopup('Success', 'Account and subscription was created.')
            } else {
              this.showInfoPopup('Success', 'Subscription was created.')
            }
          } else {
            this.showInfoPopup('Error', createFreeSubscriptionRes.data.message)
          }
      },
      clear () {
        this.email = '';
        this.account = null;
        this.firstName = '';
        this.middleName = '';
        this.lastName = '';
        this.mobile = '';
        this.password = '';
        this.selectedPlan = {
          id: 0,
          name: 'Without subscription',
        };
        this.checked = false;
        this.subscriptionDuration = '';
      },
      getPlans () {
        const nonePlan = {
          id: 0,
          name: 'Without subscription',
        };
        const plans = [nonePlan, ...this.getEnrichedSubscriptionsPlans.filter(p => p.isActive)];
        return plans;
      },
      getDisplayValuePlan (item) {
        if (item.id === 0) {
          return item.name;
        }
        return `${item.name} ${item.duration} ${item.period.name} subscription - $${item.price}/${item.period.name.toLowerCase()}`
      },
      showInfoPopup (title, text) {
        this.$modal.show('InfoPopup', {
          title,
          text,
        })
      },
    },
    computed: {
      ...mapGetters([
        'getEnrichedSubscriptionsPlans',
      ]),
    },
    components: {
      InfoPopup,
    },
}
</script>
